import React, { useState } from 'react';
import { Logo } from '../components/Logo';
import { RegistrationForm } from '../components/RegistrationForm';
import { useStore } from '../lib/store';
import { KeyRound, Check } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
interface LandingPageProps {
  onRegisterSuccess?: () => void;
}
export function LandingPage({
  onRegisterSuccess
}: LandingPageProps) {
  const [hasCode, setHasCode] = useState(false);
  const [staffCode, setStaffCode] = useState('');
  const [error, setError] = useState(false);
  const handleCodeSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (staffCode.length >= 4) {
      setHasCode(true);
      setError(false);
    } else {
      setError(true);
    }
  };
  return <main className="min-h-screen w-full bg-gradient-to-b from-[#67E8F9] to-[#E0F2FE] flex flex-col items-center py-8 px-4 sm:px-6 lg:px-8" data-id="element-575">
      <div className="w-full max-w-md flex flex-col items-center space-y-6" data-id="element-576">
        <div className="transform scale-75 origin-top" data-id="element-577">
          <Logo data-id="element-578" />
        </div>

        <div className="w-full bg-white rounded-3xl p-6 shadow-xl animate-in slide-in-from-bottom-4 duration-500" data-id="element-579">
          {!hasCode ? <div className="text-center" data-id="element-580">
              <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-4" data-id="element-581">
                <KeyRound className="w-8 h-8 text-blue-600" data-id="element-582" />
              </div>
              <h1 className="text-2xl font-black text-gray-900 mb-2" data-id="element-583">
                Fånga din box
              </h1>
              <p className="text-gray-500 text-sm mb-6" data-id="element-584">
                Ange koden du fått av personalen för att registrera din catch.
              </p>

              <form onSubmit={handleCodeSubmit} className="space-y-4" data-id="element-585">
                <Input placeholder="ANGE KOD" value={staffCode} onChange={e => setStaffCode(e.target.value.toUpperCase())} className="text-center text-2xl tracking-widest uppercase font-mono" autoFocus data-id="element-586" />
                {error && <p className="text-red-500 text-xs" data-id="element-587">
                    Ogiltig kod. Försök igen.
                  </p>}
                <Button type="submit" className="w-full" data-id="element-588">
                  Registrera Catch
                </Button>
              </form>
            </div> : <>
              {/* Minimal transition — let the form handle all messaging */}
              <div className="flex items-center justify-center mb-4" data-id="element-589">
                <span className="bg-green-100 text-green-800 text-xs font-bold px-3 py-1 rounded-full flex items-center" data-id="element-590">
                  <Check className="w-3 h-3 mr-1" data-id="element-591" />
                  Kod godkänd
                </span>
              </div>
              <RegistrationForm onSuccess={onRegisterSuccess} isWalkIn={true} data-id="element-592" />
            </>}
        </div>

        <p className="text-blue-900/60 text-xs text-center max-w-xs" data-id="element-593">
          Genom att registrera dig godkänner du SMS-uppdateringar om framtida
          drops.
        </p>
      </div>
    </main>;
}